import { createContext } from 'react';

const UserContext = createContext();

const UserProvider = ({children, user, containerPath, appList, terms, activeTerm}) => {
    return (
        <UserContext.Provider value={{
            user: user, containerPath: containerPath, appList: appList, terms: terms, activeTerm: activeTerm
            }}>
            {children}
        </UserContext.Provider>
    );
};

export { UserContext, UserProvider };
